import { useState } from 'react';
import { useLazyECardNewFilesQuery } from '../../../graphql/graphql';
import { useAppContext } from '../../../Services/AppContext';

export default function useWorkplacePatientsFiles() {
	const { workplaceId } = useAppContext();
	const [getDocumentationFilesQuery, { data, isLoading }] =
		useLazyECardNewFilesQuery();
	const [page, setPage] = useState(1);
	const getDocumentationFiles = (filter?: object) => {
		getDocumentationFilesQuery({
			...filter,
			workplaceId: workplaceId,
			pagination: {
				skip: (page - 1) * 20,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getDocumentationFiles, getNextPage, data, isLoading, page, setPage };
}
